import { render, staticRenderFns } from "./facebook-auth.vue?vue&type=template&id=72525072&"
import script from "./facebook-auth.vue?vue&type=script&lang=js&"
export * from "./facebook-auth.vue?vue&type=script&lang=js&"
import style0 from "./facebook-auth.vue?vue&type=style&index=0&id=72525072&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports